import React, { useEffect } from 'react';
import LOGO from '../../Assets/Logo.png';
import { FaTwitter, FaLinkedin, FaYoutube, FaFacebook } from 'react-icons/fa';
import { AiFillInstagram } from "react-icons/ai";
import { useNavigate, useLocation } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleNavigation = (path, close) => {
    navigate(path);
    if (close) close();
  };

  return (
    <section className="py-4 bg-gray-50 sm:pt-16 lg:pt-14">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-2 md:col-span-3 lg:grid-cols-6 gap-y-16 gap-x-12">
          <div className="col-span-2 md:col-span-3 lg:col-span-2 lg:pr-8">
            <a href="https://phoebecompasspoint.com">
              <img className="w-auto h-16" src={LOGO} alt="Phoebe Compass Point Logo" />
            </a>
            <p className="text-base leading-relaxed text-gray-600 mt-7 font-montserrat">
              At Phoebe Compass Point, we are dedicated to providing compassionate, culturally sensitive, and personalized mental health care.
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase font-serif">Quick Links</p>
            <ul className="mt-6 space-y-4">
              <li>
                <button
                  onClick={() => handleNavigation('/')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/About')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/Services')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/Contact')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase font-serif">Help</p>
            <ul className="mt-6 space-y-4">
              <li>
                <button
                  onClick={() => handleNavigation('/Insurance')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Partnership
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/Contact')}
                  className="flex text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Appointment
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('my_modal_3').showModal()}
                  className="cursor-pointer text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Terms & Conditions
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('my_modal_4').showModal()}
                  className="cursor-pointer text-base text-black transition-all duration-200 hover:text-[#4ADE80] focus:text-[#4ADE80] font-montserrat"
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="col-span-2 md:col-span-1 lg:col-span-2 lg:pl-8">
            <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase font-serif">Follow us</p>
            <ul className="flex items-center space-x-3 mt-6">
              <li>
                <a
                  href="https://x.com/PhoebeCompass"
                  title="Twitter"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#4ADE80] focus:bg-[#34C759]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@PhoebeCompassPoint/featured"
                  title="YouTube"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#4ADE80] focus:bg-[#34C759]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/"
                  title="LinkedIn"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#4ADE80] focus:bg-[#34C759]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/"
                  title="Instagram"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#4ADE80] focus:bg-[#34C759]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillInstagram className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/"
                  title="Facebook"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#4ADE80] focus:bg-[#34C759]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook className="w-4 h-4" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="mt-16 mb-10 border-gray-200 w-full" />
        <p className="text-sm text-center text-gray-600 font-montserrat">© Copyright 2024 All Rights Reserved by Phoebe Compass Point</p>
      </div>
    </section>
  );
}

export default Footer;
